export default __webpack_public_path__ + "static/media/icon-14.85491320.svg";